<template>
  <modal :id="modalId" :title="task.task">

    <div class="row">

      <div class="col-md-6">
        <dl class="row m-b-none">
          <dt class="col-md-6">Status:</dt>
          <dd class="col-md-6 pl-0">{{ task.status }}</dd>
          <dt class="col-md-6">Due Date:</dt>
          <dd :class="'col-md-6 pl-0' + (task.expired ? ' text-danger' : '')">{{ task.date.due_date }}</dd>
          <dt class="col-md-6">Created:</dt>
          <dd class="col-md-6 pl-0">{{ task.date.created_at }}</dd>
          <dt class="col-md-6">Updated:</dt>
          <dd class="col-md-6 pl-0">{{ task.date.updated_at }}</dd>

          <template v-if="task.completed_at">
            <dt class="col-md-6">Completed:</dt>
            <dd class="col-md-6 pl-0">{{ task.date.completed_at }}</dd>
            <dt class="col-md-6">Completed by:</dt>
            <dd class="col-md-6 pl-0">{{ task.user_completed.first_name }} {{ task.user_completed.last_name }}</dd>
          </template>
        </dl>
      </div>

      <div class="col-md-6">
        <ul class="list-group">
          <li v-for="user in task.assignee_list"
              class="list-group-item d-flex justify-content-between align-items-center">
            <a :href="user.link" target="_blank" :class="(replaced(user) ? 'text-danger' : '')">{{ user.name }}</a>
            <span v-if="user.type_label" class="badge badge-secondary badge-pill">{{ user.type_label }}</span>
          </li>
        </ul>
      </div>

    </div>

    <template #footer>
      <button type="button" class="btn btn-default" @click="hideModal">Close</button>
    </template>

  </modal>
</template>

<script>
  import HasModal from "./../mixins/HasModal";

  export default {
    mixins: [HasModal],

    /**
     * Input properties
     */
    props: {
      modelValue: {
        type: Object
      },

      // Modal dialog id
      modalId: {
        type: String,
        default: "taskViewModal"
      },

      // Claim users by type.
      claimUsers: {
        type: Object,
        default: () => {}
      },

    },

    /**
     * Variables (models)
     */
    data() {
      return {
        // Current task object
        task: {},
      }
    },

    /**
     * Functions (methods).
     */
    methods: {

      /**
       * Is claim role user replaced (e.g. adjuster).
       */
      replaced(user) {
        if (user.type === '') return false;
        if (this.claimUsers[user.type] !== undefined) {
          if (this.claimUsers[user.type].id !== user.id) {
            return true;
          }
        }
        return false;
      },

    },

    /**
     * Watchers
     */
    watch: {
      modelValue: {
        handler: function (val) {
          // Clone value prop to task object to avoid prop direct modification
          this.task = _.cloneDeep(val);
        },
        immediate: true
      },
    }

  }
</script>

<style scoped>

</style>
